export default __webpack_public_path__ + "v3.414/youtube-icon.png";